/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Embedding_Hint_HoursInputs */



/**
* | output |
* | --- |
* | "Embedding ~{count} files will take several hours. You can close this page — embedding continues in the background." |
*
* @param {Spaces_Embedding_Hint_HoursInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_embedding_hint_hours = /** @type {((inputs: Spaces_Embedding_Hint_HoursInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Embedding_Hint_HoursInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Einbettung von ~${i?.count} Dateien wird mehrere Stunden dauern. Sie können diese Seite schließen — die Einbettung läuft im Hintergrund weiter.`)
	return /** @type {LocalizedString} */ (`Embedding ~${i?.count} files will take several hours. You can close this page — embedding continues in the background.`)
});